import { ComponentProps, FC, ReactNode } from 'react';

import clsx from 'clsx';

import styles from './o2-rebrand-theme.module.scss';

export interface O2RebrandThemeProps
  extends Omit<ComponentProps<'div'>, 'className'> {
  className?: string;
  children: Readonly<ReactNode>;
}

export const O2RebrandTheme: FC<O2RebrandThemeProps> = ({
  children,
  className,
  ...props
}) => (
  <div className={clsx(styles['host'], className)} {...props}>
    {children}
  </div>
);
